namespace $.$$ {

	$mol_style_define( $shm_date_view, {
		Calendar_tools: { width: '100%' },
		Calendar_title: { flex: { grow: 1 } },
	} )

	$mol_style_define( $shm_date_calendar, {
		Head: { width: 'auto' },
		Day_button: {
			'[shm_date_selected]': {
				true: {
					color: $mol_theme.current,
				},
			},
			'[disabled]': {
				true: {
					opacity: .35,
					color: $mol_theme.shade,
				},
			},
		},
	} )

}
